import { render } from "./SwitchInput.vue?vue&type=template&id=2af41b1d&scoped=true&ts=true"
import script from "./SwitchInput.vue?vue&type=script&lang=ts"
export * from "./SwitchInput.vue?vue&type=script&lang=ts"

import "./SwitchInput.vue?vue&type=style&index=0&id=2af41b1d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af41b1d"]])

export default __exports__